import React, { useEffect, useState } from "react";
import { Grid, Button, Typography, InputLabel, FormControl } from "@mui/material";
import { Input, NumericTextBox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Dialog } from "@progress/kendo-react-dialogs";
import {
  FILINGSTATUS_SINGLE,
  FILINGSTATUS_MARRIED,
} from "../../shared/constants";
import InfoIcon from "@mui/icons-material/Info";
import WarningModal from "../generic-warning-modal";
import { useModal } from '../../hooks/useModal';
import UserMenu from "../user-menu";
import { useHistory, useLocation } from "react-router-dom";


const AdditionalInformation = (props) => {

  const close = (e) => {
    props.save();
  }

  const handleChange = (valueChange, idQuestion, valueAnswers) => {

    AdditionalInformation.updateAdditional({
      answer: valueChange.target.value,
      clientQuestionId: valueAnswers === undefined ? null : valueAnswers.clientQuestionId,
      questionId: idQuestion,
      editIndex: valueAnswers === undefined ? null : valueAnswers.editIndex
    })
  }

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography component={"h1"}>Personal Information Additional Information</Typography>
        </Grid>
        {props.questions.map(e => {
          const valueAnswers = props.answers.find((answer) => answer?.questionId === e.id)
          return (
            <Grid key={e.id} item xs={12}>
              <Input
                onChange={(valueChange) => { handleChange(valueChange, e.id, valueAnswers) }}
                value={valueAnswers?.answer}
                label={e.question} />
            </Grid>)
        })}
      </Grid>
      <Grid container mt={'25px'} >
        <Grid item xs={12} display={'flex'} justifyContent={'center'}>
          <Button m={'0'} onClick={close}>close</Button>
        </Grid>
      </Grid>
    </>
  );
};

const PersonalInformation = (props) => {
  const { isOpen, openModal, closeModal } = useModal();
  const [state, setState] = useState({
    showAdditionalInformationModal: false,
  });
  const { pathname } = useLocation();
  AdditionalInformation.updateAdditional = props.updateAdditional;

  const generateYearOptions = (currentAge) => {
    const startRetirmentAge = currentAge >= 60 ? 60 : currentAge;
    const yearOptions = [
      {
        year: null,
        value: startRetirmentAge,
      },
    ];


    for (let age = startRetirmentAge + 1; age < 101; age++) {
      yearOptions.push({
        year: age,
        value: age,
      });
    }

    return yearOptions;
  };

  const filingStatusOptions = [
    {
      id: FILINGSTATUS_SINGLE,
      value: "Single",
    },
    {
      id: FILINGSTATUS_MARRIED,
      value: "Married",
    },
  ];

  const addSpouse = () => {
    props.updateClient("hasSpouse")({
      value: true,
    });
  };

  const removeSpouse = () => {
    openModal();
  };

  const doRemoveSpouse = () => {
    props.updateSpouse(null)(null)
    props.updateClient("hasSpouse")({
      value: false,
    });
    closeModal();
  }

  const saveAdditionalInfo = () => {
    setState({
      ...state,
      showAdditionalInformationModal: false,
    });
  };

  const historyBackClientList = useHistory();
  const backToClientList = () => {
    historyBackClientList.push(`/ifw-users/2/${props.fpid}`);
  };

  return (
    <React.Fragment>
      <Grid container spacing={3} className={"personal-information"}>
        <Grid container>

          <Grid item xs={6} display={'flex'} alignItems={'center'}>
            <Typography className={"personal-information-title"} component={"h1"} alignContent={'center'} >
              Personal Information {(
                <InfoIcon
                  onClick={() => {
                    setState({
                      ...state,
                      showAdditionalInformationModal: true,
                    });
                  }}
                />)}
            </Typography>
          </Grid>
          <Grid item xs={12} mt={2} ml={'1.17em'} >
            <Grid container display={"flex"} >
              <Grid item xs={6} display={"flex"} flexDirection={"row"} >
                <Grid mr={3}>
                  {!props.client.hasSpouse && (
                    <Button style={{ height: "100%" }} onClick={addSpouse}>Add Spouse</Button>
                  )}
                  {props.client.hasSpouse && (
                    <Button style={{ height: "100%" }} onClick={removeSpouse}>Remove Spouse</Button>
                  )}
                </Grid>
                <Button onClick={props.exportPdf} > Fact Finder </Button>
              </Grid>

              <Grid item xs={6} display={"flex"} justifyContent={'flex-end'} >
              </Grid>
            </Grid>

          </Grid>
        </Grid>
        <Grid className={"button-container"} item xs={12}></Grid>
        <Grid item xs={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Input
                label={"First Name"}
                value={props.client.firstName}
                onChange={props.updateClient("firstName")}
                maxLength={15}
                valid={props.validations.client.firstName.valid}
                disabled={props.readOnly}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label={"Last Name"}
                value={props.client.lastName}
                onChange={props.updateClient("lastName")}
                maxLength={15}
                valid={props.validations.client.lastName.valid}
                disabled={props.readOnly}
              />
            </Grid>
            <Grid item xs={12}>
              <NumericTextBox
                label={"Age"}
                value={props.client.age}
                onChange={props.updateClient("age")}
                min={0}
                max={110}
                valid={props.validations.client.age.valid}
                disabled={props.readOnly}
              />
            </Grid>
            <Grid item xs={12}>
              <DropDownList
                label={"Target Retire Date"}
                value={props.client.retirementAge}
                data={generateYearOptions(props.client.age)}
                dataItemKey={"year"}
                textField={"value"}
                onChange={props.updateClient("retirementAge")}
                valid={props.validations.client.retirementAge.valid}
                disabled={props.readOnly}
              />
            </Grid>
            <Grid item xs={12}>
              <DropDownList
                label={"Filing Status"}
                value={props.client.filingStatus}
                data={filingStatusOptions}
                dataItemKey={"id"}
                textField={"value"}
                onChange={props.updateClient("filingStatus")}
                valid={props.validations.client.filingStatus}
                disabled={props.readOnly}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          {props.client.hasSpouse && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Input
                  label={"First Name"}
                  value={props.spouse?.firstName}
                  onChange={props.updateSpouse("firstName")}
                  maxLength={15}
                  valid={props.validations.spouse.firstName.valid}
                  disabled={props.readOnly}
                />
              </Grid>
              <Grid item xs={12}>
                <Input
                  label={"Last Name"}
                  value={props.spouse?.lastName}
                  onChange={props.updateSpouse("lastName")}
                  maxLength={15}
                  valid={props.validations.spouse.lastName.valid}
                  disabled={props.readOnly}
                />
              </Grid>
              <Grid item xs={12}>
                <NumericTextBox
                  label={"Age"}
                  value={props.spouse?.age}
                  onChange={props.updateSpouse("age")}
                  min={0}
                  max={110}
                  valid={props.validations.spouse.age.valid}
                  disabled={props.readOnly}
                />
              </Grid>
              <Grid item xs={12}>
                <DropDownList
                  label={"Target Retire Date"}
                  value={props.spouse?.retirementAge}
                  data={generateYearOptions(props.spouse?.age)}
                  dataItemKey={"year"}
                  textField={"value"}
                  onChange={props.updateSpouse("retirementAge")}
                  valid={props.validations.retirementAge}
                  disabled={props.readOnly}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      {state.showAdditionalInformationModal && (
        <Dialog
          width={'1300px'}
          onClose={() => {
            setState({
              ...state,
              showAdditionalInformationModal: false,
            });
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <AdditionalInformation
            questions={props.questions}
            answers={props.answers}
            save={saveAdditionalInfo}
          />
        </Dialog>
      )}
      <WarningModal
        open={isOpen}
        handleClose={closeModal}
        handleOk={doRemoveSpouse}
        title={"Warning"}
        message={"Are you sure you want to remove the spouse?"}
      />
    </React.Fragment>
  );
};

export default PersonalInformation;
